export default "__VITE_ASSET__BKj4QDUH__"